module.exports = __webpack_public_path__ + "static/img/null-data.5035134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/null-data.png
// module id = HmR9
// module chunks = 12